import { createIcon } from '@chakra-ui/react'

export const Filter = createIcon({
  displayName: 'Filter',
  viewBox: '0 0 12 8',
  d: 'M4.66667 8H7.33333V6.66667H4.66667V8ZM0 0V1.33333H12V0H0ZM2 4.66667H10V3.33333H2V4.66667Z',
})
